<template>
    <div id="appointment-list">
        <div class="row topactionform">
            <div :class="typePage === 'LIST_REGULAR_USER' ? 'col-xs-4' : 'col-xs-7'" style="padding-right: 0">
                <div class="smalltitle">List {{getPageName}}
                  <span><a href="javascript:void(0)" @click="showTextUser()" class="light">Onboarding instruction</a></span>
                  <span style="margin-left: 10px"><a class="light" href="javascript:void(0)" @click="showTextEPCS()">EPCS Standard Operation Procedure</a></span>
                  <span style="display: block; font-weight: normal; font-size: 14px;">Total: {{ paginate.total }}</span>
                </div>
            </div>
            <div :class="typePage === 'LIST_REGULAR_USER' ? 'col-xs-8' : 'col-xs-5'">
                <form class="onelineform flowsearch" @submit.prevent="filterDoctor">
                    <button type="submit" class="submit btn light" style="float: right; width: 10%"><i
                            class="fa fa-search"></i></button>
                    <span v-if="typePage === 'LIST_REGULAR_USER'" class="selectwrap" style="width: 15%; float: right">
                        <select v-model="formSearch.clinicId" @change="filterDoctor">
                            <option value="">Clinic</option>
                            <option v-for="clinic in listClinics" :key="clinic.id" :value="clinic.id">{{ clinic.fullName }}</option>
                        </select>
                    </span>
                    <span v-if="typePage === 'LIST_REGULAR_USER'" class="selectwrap" style="width: 15%; float: right">
                        <select v-model="formSearch.emrStatus" @change="filterDoctor">
                            <option value="">EMR status</option>
                            <option :value="STATUS_ACTIVE">Activated</option>
                            <option :value="0">Deactivated</option>
                        </select>
                    </span>
                    <span v-if="typePage === 'LIST_REGULAR_USER'" class="selectwrap" style="width: 15%; float: right">
                        <select v-model="formSearch.status" @change="filterDoctor">
                            <option value="">Account status</option>
                            <option :value="STATUS_ACTIVE">Activated</option>
                            <option :value="0">Deactivated</option>
                        </select>
                    </span>
                    <input type="text" placeholder="Name or leave blank for search all"
                           v-model="formSearch.keySearch"
                           class="keyinput" :style="typePage === 'LIST_REGULAR_USER' ? 'width: 20%; border-left: 1px solid #e1e1e1; float: right' : 'width: 50%; border-left: 1px solid #e1e1e1; float: right'">
                </form>
            </div>
        </div>
        <div class="blockcont">
            <ul class="itemlisttable  ptemr-list">
                <li class="itemlisthead">
                    <div class="item-name">Full Name</div>
                    <div class="item-dob">DOB</div>
                    <div class="item-created-at">Created</div>
                    <div class="item-clinic">Clinic</div>
                    <div class="item-clinic">Group</div>
                    <div class="item-account-status">Account status</div>
                    <div class="item-account-status">Email Status</div>
                    <div class="item-emr-status">EMR status</div>
                    <div class="item-sure-status">Surescripts status</div>
                    <div class="item-proof">ID Proof</div>
                    <div class="item-action itemaction">Action</div>
                </li>
                <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt"><i
                        class="fas fa-spinner fa-spin"></i></li>
                <li v-if="!isLoading && dataDoctors.length === 0" style="text-align: center; font-size: 16pt">
                    No records found
                </li>
                <li v-if="!isLoading" class="item-doctor" v-for="(doctor, index) in dataDoctors">
                    <div class="item-name" @click="showDetailUser(doctor)">
                        <div class="avatar-user" :style="'background-image: url('+doctor.avatar+')'"></div>
                        {{doctor.fullName}}
                    </div>
                    <div class="item-dob">
                        {{formatAgeFromBirthday(doctor.birthDay)}}
                        <span v-if="doctor.gender" title="Sex">{{doctor.gender}}</span>
                        <div style="font-weight: normal !important; font-size: 10px !important;"
                             title="Date of Birth">{{ formatBirthDay(doctor.birthDay) }}
                        </div>
                    </div>
                    <div class="item-created-at">{{formatTime(doctor.createdAt)}}</div>
                    <div class="item-clinic" :title="doctor.clinic">{{ doctor.clinic }}</div>
                    <div class="item-clinic" :title="doctor.group">{{ doctor.group }}</div>
                    <div class="item-status">{{getStatusText(doctor.status)}}</div>
                    <div class="item-account-status">N/A</div>
                    <div class="item-emr-status">{{getStatusText(doctor.emr_status)}}</div>
                  <div class="item-sure-status">
                    <div :title="getTitleSurescriptDoctor(doctor)" class="item-surescript-status-text"
                         @click.prevent="showSureScript(doctor)">e-Rx:
                      {{ getStatusSurescriptDoctor(doctor) }}
                    </div>
                    <div  v-if="!doctor.requestUpdateControlledSubstance" :title="getTitleEPCS(doctor)" class="item-surescript-status-text"
                          @click.prevent="showSureScript(doctor)">EPCS: {{ getEPCSStatus(doctor) }}
                    </div>
                    <div v-if="doctor.requestUpdateControlledSubstance" class="item-surescript-status-text"
                         style="color: #bec500"
                         @click="showModalApproveEPCS(doctor)">EPCS - Pending
                    </div>
                  </div>

                  <div class="item-proof">
                    <i class="fas fa-fingerprint" @click.prevent="showIdProof(doctor)"></i>

                    <img src="/img/authentication_logo.png" style="margin-left: 5px;width: 15px"
                         @click.prevent="showAuthenticationModal(doctor)">
                  </div>
                    <div class="item-action itemaction">
                        <dropdown>
                            <a href="javascript:void(0)" title="Action" data-toggle="dropdown">
                                <i class="fa fa-cog"
                                   aria-hidden="true"></i></a>
                            <template slot="dropdown">
                                <div><a :href="getLinkProfileAccount(doctor.id)"
                                        target="_blank"
                                >Profile</a>
                                </div>
                                <div><a href="javascript:void(0)"
                                        @click.prevent="loginAsEmr(doctor)">Login as EMR</a>
                                </div>
                                <div><a href="javascript:void(0)"
                                        @click.prevent="changeStatusAccount(doctor)">{{getStatusAccountAction(doctor)}}</a>
                                </div>
                                <div><a href="javascript:void(0)"
                                        @click.prevent="changeStatusEmr(doctor)">{{getStatusEmrAction(doctor)}}</a>
                                </div>
                              <div><a href="javascript:void(0)"
                                      @click.prevent="showModalSetNewPassword(doctor)">Set new password</a>
                              </div>
                            </template>
                        </dropdown>
                    </div>
                </li>
            </ul>
        </div>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>
        <detail-regular-user
                v-if="detailRegular.modal"
                :user="detailRegular.user"
                @updateModal="detailRegular.modal = $event"
        >
        </detail-regular-user>
        <id-proof-modal
                v-if="detailIdProof.modal"
                :user="detailIdProof.user"
                @updateModal="detailIdProof.modal = $event"
        >
        </id-proof-modal>
      <set-new-password v-if="dataNewPassword.modal"
                        @updateModal="dataNewPassword.modal = $event"
                        :user="dataNewPassword.user"
      >
      </set-new-password>
      <sure-script-modal v-if="dataSureScriptModal.modal"
                         @updateModal="dataSureScriptModal.modal = $event"
                         :user="dataSureScriptModal.doctor"
                         @updateDataDoctor="updateDataDoctor"
      >

      </sure-script-modal>
      <authentication-modal v-if="dataAuthenticationModal.modal"
                            @updateModal="dataAuthenticationModal.modal = $event"
                            :user="dataAuthenticationModal.user"
      >
      </authentication-modal>

      <text-info-user
          v-if="textUserModal"
          @updateModal="textUserModal = $event"
      >
      </text-info-user>

      <e-c-p-s-info-user v-if="textEPCSModal"
                         @updateModal="textEPCSModal = $event">
      </e-c-p-s-info-user>
      <modal-approval-epcs v-if="dataApproveEpcs.modal"
                           :doctor="dataApproveEpcs.doctor"
                           @finishApproval="loadListDoctor"
                           @updateModal="dataApproveEpcs.modal = $event"
      >

      </modal-approval-epcs>
    </div>
</template>

<script>
import Pagination from '../../global/Pagination.vue'
import axios from '../../client'
import CommonMixin from '../../mixins/general/CommonMixin.vue'
import TimeMixin from '../../mixins/general/TimeMixin.vue'
import UserStatusMixin from '../../mixins/user/UserStatusMixin'
import SurescriptDoctorMixin from '../../mixins/user/SurescriptDoctorMixin.vue'
import ModalApprovalEpcs from '@/components/users/part/doctor/ModalApprovalEpcs.vue'
const DetailRegularUser = () => import('./part/DetailRegularUser')
const IdProofModal = () => import('./part/IdProofModal')
const SetNewPassword = () => import('./part/SetNewPassword')
const SureScriptModal = () => import('./part/SureScriptModal')
const AuthenticationModal = () => import('./part/AuthenticationModal.vue')

const TextInfoUser = () => import('./part/TextInfoUser.vue')
const ECPSInfoUser = () => import('./part/ECPSInfoUser.vue')
export default {
  name: 'Doctor',
  components: {
    ModalApprovalEpcs,
    Pagination,
    DetailRegularUser,
    IdProofModal,
    SetNewPassword,
    SureScriptModal,
    AuthenticationModal,
    TextInfoUser,
    ECPSInfoUser
  },
  mixins: [CommonMixin, TimeMixin, UserStatusMixin, SurescriptDoctorMixin],
  data () {
    return {
      typePage: 'LIST_REGULAR_USER',
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isLoading: false,
      dataDoctors: [],
      formSearch: {
        keySearch: '',
        emrStatus: '',
        status: '',
        clinicId: ''
      },
      listClinics: [],

      detailRegular: {
        modal: false,
        user: {}
      },
      detailDoctor: {
        modal: false,
        user: {}
      },
      detailIdProof: {
        modal: false
      },
      dataNewPassword: {
        modal: false,
        user: {}
      },
      dataSureScriptModal: {
        modal: false,
        doctor: {}
      },
      dataAuthenticationModal: {
        modal: false,
        user: {}
      },
      textUserModal: false,
      textEPCSModal: false,
      dataApproveEpcs: {
        modal: false,
        doctor: null
      }
    }
  },
  computed: {
    getPageName () {
      if (this.typePage === 'LIST_DOCTOR') {
        return 'Physician'
      }
      return 'Regular User'
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    if (this.$route.name === 'list-doctor') {
      this.typePage = 'LIST_DOCTOR'
    }
    if (this.typePage === 'LIST_REGULAR_USER') {
      this.loadListClinics()
    }
    this.loadListDoctor()
  },
  beforeDestroy () {
  },
  methods: {
    async loginAsEmr (doctor) {
      try {
        let response = await axios.post(`/users/login-as-emr`, {
          userId: doctor.id
        })
        if (response.data.s === 200) {
          window.open(response.data.data.redirectUrl, '_blank')
          return
        }
        this.alertError(response.data.msg)
      } catch (e) {
        this.alertError('Server error.Try again later')
      }
    },
    showModalApproveEPCS (doctor) {
      this.dataApproveEpcs.doctor = doctor
      this.dataApproveEpcs.modal = true
    },
    showAuthenticationModal (doctor) {
      this.dataAuthenticationModal.user = doctor
      this.dataAuthenticationModal.modal = true
    },
    updateDataDoctor () {
      this.loadListDoctor()
    },
    showSureScript (doctor) {
      this.dataSureScriptModal.modal = true
      this.dataSureScriptModal.doctor = doctor
    },
    showModalSetNewPassword (doctor) {
      this.dataNewPassword.modal = true
      this.dataNewPassword.user = doctor
    },
    showIdProof (doctor) {
      this.detailIdProof.user = doctor
      this.detailIdProof.modal = true
    },
    showDetailUser (user) {
      if (this.typePage === 'LIST_REGULAR_USER') {
        this.detailRegular.modal = true
        this.detailRegular.user = user
      }
    },
    filterDoctor () {
      this.paginate.page = 1
      this.loadListDoctor()
    },
    async loadListClinics () {
      let response = await axios.get(`/clinics`, { params: { page: 1, perPage: 1000 } })
      try {
        if (response.data.s === 200) {
          this.listClinics = response.data.data.clinics ? response.data.data.clinics : []
        }
      } catch (e) {
      }
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadListDoctor()
    },
    async loadListDoctor () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      let params = {
        page: this.paginate.page,
        perPage: this.paginate.perPage,
        keySearch: this.formSearch.keySearch,
        typePage: this.typePage
      }
      if (this.typePage === 'LIST_REGULAR_USER') {
        params.emrStatus = this.formSearch.emrStatus
        params.status = this.formSearch.status
        params.clinicId = this.formSearch.clinicId
      }
      let response = await axios.get(`/users/list`, { params: params })
      this.isLoading = false
      try {
        if (response.data.s === 200) {
          this.dataDoctors = response.data.data.users ? response.data.data.users : []
          this.paginate.page = Number(response.data.data.currentPage)
          this.paginate.total = response.data.data.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
      }
    },
    showTextUser () {
      this.textUserModal = true
    },
    showTextEPCS () {
      this.textEPCSModal = true
    }
  }
}
</script>
<style>

</style>
<style scoped="">
    .avatar-user {
        width: 20px !important;
        padding-bottom: 20px !important;
        display: inline-block !important;
        border-radius: 50% !important;
        vertical-align: middle !important;
        background-size: cover;
        background-position: top center;
        height: 0;
        background-color: #e1e1e1;
        overflow: hidden;
    }

    .item-name {
      width: 15% !important;
      min-height: 1px;
      cursor: pointer;
    }

    .item-dob {
        width: 5% !important;
        min-height: 1px;

    }

    .item-created-at {
        width: 5% !important;
    }
    .item-clinic {
        width: 10% !important;
        text-align: left !important;
    }
    .item-proof {
        min-height: 1px;
        width: 10% !important;
        text-align: center !important;
    }
    .item-status {
        width: 10% !important;
        min-height: 1px;
    }

    .item-account-status {
        width: 10% !important;
        text-align: center !important;
    }

    .item-emr-status {
      width: 10% !important;
      text-align: center !important;
    }
    .item-sure-status {
      width: 10% !important;
      text-align: center !important;
      min-height: 1px;
      cursor: pointer;
    }

    .item-action {
        width: 5% !important;
        float: right !important;
        min-height: 1px;
        padding-right: 5px;
        text-align: right !important;
    }

    .onelineform {
        border-left: none !important;
    }
</style>
